import { useEffect, useState } from 'react';

/**
 * A clock that re-renders its component on a fixed cadence.
 *
 * Anything that shows elapsed time needs one: reading `Date.now()` straight from render is impure —
 * the same props would produce different output — and would also freeze, because nothing tells React
 * that the number changed. Pass `null` to stop ticking when nothing on screen is counting.
 */
export function useNow(intervalMs: number | null = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    // Still refresh once when the ticking stops, so the last frame isn't a stale reading.
    setNow(Date.now());
    if (intervalMs === null) return;

    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
